export default __webpack_public_path__ + "static/media/search.58326e88.svg";